import React from 'react'

const SvgHeartFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 20.994c-.322-.003-.708-.158-1.158-.465C6.652 17.375 2 14.46 2 8.995 2 5.627 4.42 3 7.5 3c1.74 0 3.41.883 4.5 2.267C13.09 3.883 14.76 3 16.5 3 19.58 3 22 5.627 22 8.995c0 5.523-4.862 8.495-8.854 11.534-.442.314-.824.47-1.146.465z'
    />
  </svg>
)

export default SvgHeartFilled
